"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CalendarType = void 0;
var CalendarType;
exports.CalendarType = CalendarType;

(function (CalendarType) {
  CalendarType["ANNUAL_EVALUATION"] = "annualEvaluation";
  CalendarType["BASE"] = "base";
  CalendarType["CUSTOM_FORM"] = "customForm";
  CalendarType["FIXED_FREQUENCY"] = "fixedFrequency";
  CalendarType["GENERIC_LOG"] = "genericLog";
  CalendarType["MODULE_FORM"] = "moduleForm";
  CalendarType["ONE_TIME_FORM"] = "oneTimeForm";
})(CalendarType || (exports.CalendarType = CalendarType = {}));